import { render, staticRenderFns } from "./template_list.vue?vue&type=template&id=075b1b63"
import script from "./template_list.vue?vue&type=script&lang=ts"
export * from "./template_list.vue?vue&type=script&lang=ts"
import style0 from "./template_list.vue?vue&type=style&index=0&id=075b1b63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports